import { freshman_configuration } from "../../constants/apiUrl";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IFreshmanConfigurationData } from "../../models/freshman/configuration";
import { IApiResponse } from "../../models/IAPIResponse";

export default new (class freshmanConfigurationService {
  public createConfiguration = async (
    data: IFreshmanConfigurationData
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = freshman_configuration.CREATE_FRESHMAN_CONFIGURATION;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public getFreshmanConfiguration = async (
    studentCategoryId: number
  ): Promise<IApiResponse<IFreshmanConfigurationData>> => {
    try {
      let endPoint = urlBinder(
        freshman_configuration.GET_FRESHMAN_CONIFIGURATION,
        [`${studentCategoryId}`]
      );
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IFreshmanConfigurationData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IFreshmanConfigurationData>;
      } else {
        throw error;
      }
    }
  };

  public getAllFreshmanCofiguration = async (): Promise<
    IApiResponse<Array<IFreshmanConfigurationData>>
  > => {
    try {
      let endPoint = freshman_configuration.GET_ALL_FRESHMAN_CONFIGURATION;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IFreshmanConfigurationData>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IFreshmanConfigurationData>>;
      } else {
        throw error;
      }
    }
  };

  public updateFreshmanConfiguration = async (
      data: IFreshmanConfigurationData, studentCategoryId: number
    ): Promise<IApiResponse<boolean>> => {
      try {
        let endPoint = urlBinder(freshman_configuration.UPDATE_FRESHMAN_CONFIGURATION, [`${studentCategoryId}`]);
        const response = await APIService.put(endPoint, data);
        return response.data as IApiResponse<boolean>;
      } catch (error: any) {
        if (error.response) {
          return error.response as IApiResponse<boolean>;
        } else {
          throw error;
        }
      }
    };

    public deleteFreshmanConfiguration = async (studentCategoryId: number): Promise<boolean> => {
        try {
          let endPoint = urlBinder(freshman_configuration.INACTIVATE_FRESHMAN_CONFIGURATION, [`${studentCategoryId}`]);
          const response = await APIService.delete(endPoint);
          return response.status === 204 ? true : false;
        } catch (error: any) {
          if (error.response) {
            return false as boolean;
          } else {
            throw error;
          }
        }
      };

      public getAllInactiveVersion = async (
        studentCategoryId: number,
        versionId: number
      ): Promise<IApiResponse<IFreshmanConfigurationData>> => {
        try {
          let endPoint = urlBinder(
            freshman_configuration.GET_ALL_INACTIVE_VERSION,
            [`${studentCategoryId}`, `${versionId}`] 
          );
          const response = await APIService.get(endPoint);
          return response.data as IApiResponse<IFreshmanConfigurationData>;
        } catch (error: any) {
          if (error.response) {
            return error.response as IApiResponse<IFreshmanConfigurationData>;
          } else {
            throw error;
          }
        }
      };
})();
